import React from "react";

// const  = [
//   {
//     ques: "What time does it take to design and build a website in Hobart?",
//     ans: "This is highly dependent on the build's specifications and the speed with which you, the client, can furnish us with the data we need to begin construction. Typically, we recommend giving yourself at least four to six weeks.",
//     collapse: "collapseOne"
//   },
//   {
//     ques: "Who will be the owner of the website, me, right?",
//     ans: "Without a doubt! We are not going to hold your site hostage like other studios do. Feel free to visit and go anytime you like. But don't worry, we'll be here to help if you need us.",
//     collapse: "collapseTwo"
//   },
//   {
//     ques: "Which Content Is Necessary for My Website?",
//     ans: "If you want your content to rank higher and attract more clients, you need to apply search engine optimisation (SEO) strategies. Famous websites immediately pay close attention to what visitors want and provide the greatest user experience possible with their minimalist design. Your website should do the same.",
//     collapse: "collapseThree"
//   },
//   {
//     ques: "What time does it take to design and build a website in Hobart?",
//     ans: "This is highly dependent on the build's specifications and the speed with which you, the client, can furnish us with the data we need to begin construction. Typically, we recommend giving yourself at least four to six weeks.",
//     collapse: "collapseFour"
//   },
//   {
//     ques: "Which content management system is ideal for an online store?",
//     ans: "Having a striking online presence can help you stand out, and WordPress makes it easy to do just that. Everyone from government agencies to socialite blogs can use its user-friendly interface, whether renovating an existing website or building a new one.",
//     collapse: "collapseFive"
//   },

// ]

const Faq = ({content}) => {
  const questions = content.subheading;
  return (
    <section className="faq-area pt-120 pb-120">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6">
            <div className="faq-img">
              <img src="/img/images/faq_img.png" alt="" />
              <img src="/img/images/faq_img02.png" alt="" />
            </div>
            <div className="faq-content">
              <div className="section-title title-style-two mb-20">
                <h2 className="title">Commonly Questions Asked</h2>
              </div>
              <h3 className="title-two">& Knock Me Directly to Know More</h3>
              <p>
                These are the frequently asked questions by people regarding
                website design for Hobart business. If you have any other query
                regarding the design and development of a website, please
                contact us at your earliest convenience.
              </p>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="accordion faq-wrap" id="accordionExample">
            {questions.map(items => (
              <>  <div className="accordion-item">
              <h2 className="accordion-header" id="headingOne">
                <button
                  className="accordion-button"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target={`#${items.collapse}`}
                  aria-expanded="true"
                  aria-controls={items.collapse}
                >
                  {items.heading}
                </button>
              </h2>

              <div
                id={items.collapse}
                className="accordion-collapse collapse"
                aria-labelledby="headingOne"
                data-bs-parent="#accordionExample"
              >
                <div className="accordion-body">
                  <p>
                    {items.para}
                  </p>
                </div>
              </div>
            </div>
</>
            ))}
            </div>
          </div>
        </div>
      </div>

      <div className="faq-shape-wrap">
        <img src="/img/images/faq_shape.png" alt="" />
      </div>
    </section>
  );
};

export default Faq;
